import { IPathfindingHeuristic } from "./IPathfindingHeuristic";
import { PathfindingGraph } from "./PathfindingGraph";

/**
 * A heuristic that nudges the pathfinder search into the direction of a single target node, utilizing manhattan style distance estimation.
 * <p>It's the best heuristic for 4-way and 8-way graphs.</p>
 * @author npuschke
 *
 */
export class PathfindingHeuristicManhattan implements IPathfindingHeuristic {
    private _targetX: number;
    private _targetY: number;

    /**
     * Creates a heuristic that nudges the search towards the given target coordinates, using manhattan style distance estimation.
     * @param targetX The horizontal coordinate of the target node.
     * @param targetY The vertical coordinate of the target node.
     *
     */
    constructor(targetX: number, targetY: number) {
        this._targetX = targetX;
        this._targetY = targetY;
    }

    /**
     * Calculates the heuristic value at the given coordinates.
     * @param graph The graph that is being searched.
     * @param x The horizontal coordinate of the node to be calculated.
     * @param y The vertical coordinate of the node to be calculated.
     * @return The heuristic value of the node.
     */
    public calculate(graph: PathfindingGraph, x: number, y: number): number {
        return (Math.abs(x - this._targetX) + Math.abs(y - this._targetY)) * graph.traverseCostStandard;
    }
}
